import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export function handleVideoBanner() {
    const videoBanners = document.querySelectorAll(".pul-video-banner:not(.pul-video-banner--autoplay-video)");
   
    if (videoBanners.length > 0) {
        for (const videoBanner of videoBanners) {
            const videoWrapper = videoBanner.querySelectorAll(".pul-video-banner__video");
           

            videoWrapper.forEach(wrapper => {
                const video = wrapper.querySelector("video");
                const button = wrapper.querySelector("button");

                if (video && button) {
                    button.addEventListener("click", () => {        
                        const mq = window.matchMedia("(min-width: 768px)").matches;
                                        
                        if (video.paused) {
                            document.documentElement.style.setProperty("--scroll-padding", mq ? "95px" : "78px");
                            video.scrollIntoView({ behavior: "smooth" });
                            video.classList.add("playing");
                            video.setAttribute("controls", "");
                            video.play();
                            button.classList.add("playing");
                        }
                    });

                    video.addEventListener('seeking', () => {
                        // Optionally, add a flag to prevent triggering the pause event during seeking
                        video.seeking = true;
                    });

                    video.addEventListener('seeked', () => {
                        // After seeking, remove the flag and resume if needed
                        video.seeking = false;
                    });

                    video.addEventListener("ended", () => {
                        document.documentElement.style.removeProperty("--scroll-padding");
                        videoBanner.scrollIntoView({ behavior: "smooth" });
                        video.classList.remove("playing");
                        video.removeAttribute("controls");
                        button.classList.remove("playing");
                    });

                    video.addEventListener("pause", () => {
                        if (video.seeking) {
                            return;
                        } else {
                            document.documentElement.style.removeProperty("--scroll-padding");
                            videoBanner.scrollIntoView({ behavior: "smooth" });
                            video.classList.remove("playing");
                            video.removeAttribute("controls");
                            button.classList.remove("playing");
                        }
                    });
                }
            });
        }
    }
}

export function handleAutoplayingVideoBanner() {
    const videoBanners = document.querySelectorAll(".pul-video-banner--autoplay-video");

    if (videoBanners.length > 0) {
        for (const videoBanner of videoBanners) {
            const video = videoBanner.querySelector("video");

            const intersectionObserver = new IntersectionObserver((entries) => {
                if (entries[0].intersectionRatio >= 0.5) {
                    video.play();
                } else {
                    video.pause();
                }
            }, {
                threshold: [0, 0.25, 0.5, 0.75, 1]
            });
            // start observing
            intersectionObserver.observe(video);
        }
    }
}

export function initVideoBannerSlider() {
    const videoBannerSliders = document.querySelectorAll(".pul-video-banner .swiper");

    if (videoBannerSliders.length > 0) {
        for (const slider of videoBannerSliders) {
            new Swiper(slider, {
                modules: [Navigation, Pagination],
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    slideChangeTransitionStart: swiper => {
                        const video = swiper.slides[swiper.previousIndex].querySelector("video");
                        const playBtn = swiper.slides[swiper.previousIndex].querySelector(".pul-video-banner__video-overlay");

                        if (video) {
                            // slider.scrollIntoView({behavior: "smooth"})
                            video.classList.remove("playing");
                            video.pause();
                            video.removeAttribute("controls");
                            playBtn.classList.remove("playing");
                        }
                    }
                }
            });
        }
    }
}